module.exports = __webpack_public_path__ + "assets/logo.b36f7a7f.svg";